import React from 'react';

export default function Earn() {
	return (
		<div className="main">
			<p style={{fontSize:"20px", color:"var(--text-color)"}}>EARN</p>
		</div>
	);
}